import React, {useContext, useEffect, useState} from "react";
import './index.css'
import {ThemeContext} from "../../providers/themeContext/theme-context.tsx";
import {useUserContext} from "../../providers/userProvider/user-context.tsx";
import {PageEnum, PageProps} from "../../types/IPage.ts";
import {LocalStorageKey} from "../../types/IGameStat.ts";
import {GAEvents} from "../../common/utils/GA4/GAEvents.ts";
import {isEmptyOrNullOrUndefined} from "../../common/utils/Datautil.ts";
import {apiService} from "../../common/utils/http/api-service.ts";
import Avatar from "../../components/Avatar/Avatar.tsx";

// 跳转初始页面
const ChallengePage: React.FC<PageProps> = ({currentPage, switchPage}) => {
    // 全局用户信息provider
    const {user, aiLevel, setAiLevel, challengeWords, setChallengeWords} = useUserContext();
    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);

    // 是否显示闪电图标
    const [showLightningIcon, setShowLightningIcon] = useState(false);

    useEffect(() => {
        let timerId: string | number | NodeJS.Timeout | undefined
        setTimeout(() => {
            setShowLightningIcon(true)
        }, 200);

        if (showLightningIcon) {
            // GA埋点
            GAEvents.aiChallengePageShow();
            const aiLevelStr = localStorage.getItem(LocalStorageKey.AI_CHALLENGE_GAME_LEVEL);
            // 如果level级别是1，就获取单词列表，如果不是就不获取
            if (!aiLevelStr || challengeWords.length === 0 || !challengeWords) {
                if (currentPage === PageEnum.CHALLENGE) {
                    // 获取挑战单词的列表之后再跳转
                    loadAIGameWords().then(() => {
                        timerId = setTimeout(() => {
                            if (aiLevel === 0 || isEmptyOrNullOrUndefined(aiLevel.toString())) {
                                setAiLevel(1);
                            }

                            switchPage(PageEnum.AI_CHALLENGE_GAME)

                        }, 1000);
                    })
                }
            } else {
                timerId = setTimeout(() => {
                    switchPage(PageEnum.AI_CHALLENGE_GAME)
                }, 2000);
            }
        }
        return () => {
            clearTimeout(timerId); // 清除定时器，避免在组件卸载后执行跳转
        };

    }, [currentPage, showLightningIcon]);

    // 获取AI对战单词列表
    const loadAIGameWords = async () => {
        const response = await apiService.getAiGameWords();
        if (response.code === 200) {
            if (response.data !== null && response.data.length > 0) {
                setChallengeWords(response.data);
            }
        }
    };


    // 点击取消
    const onClickCancel = () => {
        // GA埋点
        GAEvents.aiChallengeCancelButtonClick();
        // 切换页面
        switchPage(PageEnum.HOME)
    }
    return (
        <div style={{overflow: "hidden"}}>
            {/*叠加的背景图*/}
            <div className="challenge-background-color"/>
            <div className="common-page-background-img" style={{backgroundImage: `url(${imgUrls.rectangleIcon})`}}/>
            <div className="challenge-background-color-white"/>
            <div className="display-flex-column justify-content-center align-items-center">
                <img className="margin-left-right-auto margin-top-66 width-66 height-66"
                     src={imgUrls.challengeLogoUrl} alt="img"/>
                <img className="margin-top-32 width-178  margin-left-right-auto"
                     src={imgUrls.challengeTextPicUrl} alt="img"/>
                {/*挑战加闪电*/}
                <div className="challenge-left-right-container">
                    <div
                        className="challenge-left-pic display-flex-row slide-in-element-from-left display-flex-align-items-center display-flex-justify-content-center"
                        style={{backgroundImage: `url(${imgUrls.challengeLeftCardUrl})`}}>
                        {/*内容*/}
                        {/*左边*/}
                        <div
                            className="margin-top-bottom-auto display-flex-column display-flex-align-items-center display-flex-align-content challenge-left-content-container">
                            <Avatar className="width-55 height-55 margin-right-47" />
                            <div className=" challenge-name-title margin-top-14 my-roboto-bold margin-right-47">YOU</div>
                            <div
                                className="challenge-name margin-right-47 margin-top-3 my-roboto-italic">{user?.cgtnName ?? user?.guestName}</div>
                        </div>
                        {showLightningIcon ?
                            <img id="lightingIcon" className="fade-in-animation challenge-lighting-icon"
                                 src={imgUrls.challengeLightingIconUrl}
                                 alt="img"/> : undefined}
                    </div>
                    {/*右边*/}
                    <div className="challenge-right-pic slide-in-element"
                         style={{backgroundImage: `url(${imgUrls.challengeRightCardUrl})`}}>
                        <div
                            className="display-flex-column height-100-percent margin-top-bottom-auto display-flex-align-items-center display-flex-justify-content-center">
                            <img className="challenge-avatar-img margin-left-47"
                                 src={imgUrls.aiAvatarUrl}
                                 alt="avatar"/>
                            <div className="challenge-name-title my-roboto-bold margin-top-14 margin-left-47">AI</div>
                        </div>
                    </div>

                </div>

                {/*cancel按钮*/}
                <div onClick={onClickCancel}
                     className="challenge-cancel-btn bg-color-grey margin-left-right-auto my-roboto-medium">Cancel
                </div>

            </div>
        </div>
    );
};

export default ChallengePage;